import React, { useState, useEffect } from 'react';
import { Form, Input, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { FormPageLayout } from '../../components/FormPageLayout';
import { useAutoSave } from '../../hooks/useAutoSave';

const FABEEdit: React.FC = () => {
    const { skuId, id } = useParams<{ skuId: string; id: string }>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const isNew = !id || id === 'new';

    const { triggerSave, state: saveState } = useAutoSave<any>({
        onSave: async (data) => {
            if (isNew) {
                await api.post(`/skus/${skuId}/fabe/`, data);
                message.success('FABE已创建');
                navigate(`/sku-management/edit/${skuId}`);
            } else {
                await api.put(`/skus/${skuId}/fabe/${id}/`, data);
            }
        },
        delay: 1000,
        enabled: !isNew,
        showMessage: true
    });

    useEffect(() => {
        if (!isNew) {
            fetchFABE();
        }
    }, [id]);

    const fetchFABE = async () => {
        setLoading(true);
        try {
            const res = await api.get(`/skus/${skuId}/fabe/${id}/`);
            form.setFieldsValue(res.data);
        } catch (error) {
            message.error('加载失败');
            navigate(`/sku-management/edit/${skuId}`);
        } finally {
            setLoading(false);
        }
    };

    const handleValuesChange = (_: any, allValues: any) => {
        if (!isNew) {
            triggerSave(allValues);
        }
    };

    const handleManualSave = async () => {
        try {
            const values = await form.validateFields();
            await api.post(`/skus/${skuId}/fabe/`, values);
            message.success('FABE已创建');
            navigate(`/sku-management/edit/${skuId}`);
        } catch (error) {
            // Validation error
        }
    };

    const getSaveStatus = () => {
        if (saveState.isSaving) return 'saving';
        if (saveState.hasUnsavedChanges) return 'hasChanges';
        if (saveState.lastSavedAt) return 'saved';
        return 'idle';
    };

    return (
        <FormPageLayout
            title={isNew ? '新增FABE' : '编辑FABE'}
            breadcrumbs={[
                { title: 'SKU管理', path: '/sku-management' },
                { title: 'SKU详情', path: `/sku-management/edit/${skuId}` },
                { title: isNew ? '新增FABE' : '编辑FABE' }
            ]}
            saveStatus={getSaveStatus()}
            showSaveButton={isNew}
            onSave={handleManualSave}
            saving={loading}
        >
            <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
                <Form.Item name="feature" label="Feature (特征)" rules={[{ required: true }]}>
                    <Input.TextArea rows={3} placeholder="产品的特征" />
                </Form.Item>
                <Form.Item name="advantage" label="Advantage (优势)" rules={[{ required: true }]}>
                    <Input.TextArea rows={3} placeholder="相对于竞品的优势" />
                </Form.Item>
                <Form.Item name="benefit" label="Benefit (利益)" rules={[{ required: true }]}>
                    <Input.TextArea rows={3} placeholder="给用户带来的利益" />
                </Form.Item>
                <Form.Item name="evidence" label="Evidence (证据)">
                    <Input.TextArea rows={3} placeholder="支持上述内容的证据" />
                </Form.Item>
            </Form>
        </FormPageLayout>
    );
};

export default FABEEdit;
